import React, { useEffect, useState } from 'react';
import { Col, DatePicker, InputGroup, InputGroupAddon, InputGroupText } from 'shards-react';
import moment from 'moment';
import { DATE_TYPE, SEARCH_FIELD_NAMES } from '../../../constants';
import type { DateType } from '../../../types/common';
import { useTranslation } from 'react-i18next';

interface SelectCertIssueDateProps {
  isDomestic: boolean;
  start: string; // 'YYYY-MM-DD'
  end: string; // 'YYYY-MM-DD'
  onChangeDate: (fieldName: string, value: string) => void;
}

const SelectCertIssueDate = ({ isDomestic, start, end, onChangeDate }: SelectCertIssueDateProps): JSX.Element => {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState<Date | ''>('');
  const [endDate, setEndDate] = useState<Date | ''>('');

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  useEffect(() => {
    const newStartDate: Date | '' = start !== '' && moment(start, 'YYYY-MM-DD', true).isValid() ? moment(start).startOf('days').toDate() : '';
    setStartDate(newStartDate);
  }, [start]);

  useEffect(() => {
    const newEndDate: Date | '' = end !== '' && moment(end, 'YYYY-MM-DD', true).isValid() ? moment(end).endOf('days').toDate() : '';
    setEndDate(newEndDate);
  }, [end]);

  // EVENT HANDLER
  // ================================================================================

  const handleIssueStartDateChange = (selectedDate: Date): void => {
    // console.log('selected start date has set to:', selectedDate);
    setStartDate(selectedDate);
    const formattedDate: string = moment(selectedDate).format('YYYY-MM-DD');
    onChangeDate(SEARCH_FIELD_NAMES.START_DATE, formattedDate);
  };

  const handleIssueEndDateChange = (selectedDate: Date): void => {
    // console.log('selected end date has set to:', selectedDate);
    setEndDate(selectedDate);
    const formattedDate: string = moment(selectedDate).format('YYYY-MM-DD');
    onChangeDate(SEARCH_FIELD_NAMES.END_DATE, formattedDate);
  };

  const handleDateClear = (dateType: DateType): void => {
    // console.log('clear:', dateType);
    if (dateType === DATE_TYPE.START_DATE) {
      setStartDate('');
      onChangeDate(SEARCH_FIELD_NAMES.START_DATE, '');
    } else if (dateType === DATE_TYPE.END_DATE) {
      setEndDate('');
      onChangeDate(SEARCH_FIELD_NAMES.END_DATE, '');
    }
  };

  // VIEW
  // ================================================================================

  return (
    <>
      <Col md="4" className="form-group">
        <label htmlFor="feInputCertIssueDate">{isDomestic ? t('millSheet.certIssueDate') : 'Date'}</label>
      </Col>
      <Col md="8" className="form-group">
        <InputGroup className="justify-content-end d-flex my-auto date-range">
          <DatePicker
            selected={startDate}
            onChange={handleIssueStartDateChange}
            placeholderText={t('millSheet.from')}
            dropdownMode="select"
            clearBtn={true}
            autoClose={false}
            dateFormat="yyyy/MM/dd"
          />
          <InputGroupAddon type="append" className="button-clear">
            <InputGroupText>
              <i className="material-icons" onClick={() => handleDateClear(DATE_TYPE.START_DATE)}>
                cancel
              </i>
            </InputGroupText>
          </InputGroupAddon>
          <DatePicker selected={endDate} onChange={handleIssueEndDateChange} placeholderText={t('millSheet.to')} dropdownMode="select" clearBtn={true} autoClose={false} dateFormat="yyyy/MM/dd" />
          <InputGroupAddon type="append" className="button-clear">
            <InputGroupText>
              <i className="material-icons" onClick={() => handleDateClear(DATE_TYPE.END_DATE)}>
                cancel
              </i>
            </InputGroupText>
          </InputGroupAddon>
        </InputGroup>
      </Col>
    </>
  );
};

export default SelectCertIssueDate;
